const PRESENCE_ACTION_PREFIX = '@@app/presence'
const makeConstant = (constant) => `${PRESENCE_ACTION_PREFIX}/${constant}`

export const PRESENCE_DIFF = makeConstant('PRESENCE_DIFF')
export const PRESENCE_DIFF_LEAVES = makeConstant('PRESENCE_DIFF_LEAVES')

export const SEND_WELCOME_MESSAGE = makeConstant('SEND_WELCOME_MESSAGE')
export const SEND_WELCOME_MESSAGE_SUCCESS = makeConstant('SEND_WELCOME_MESSAGE_SUCCESS')
export const SEND_WELCOME_MESSAGE_FAILURE = makeConstant('SEND_WELCOME_MESSAGE_FAILURE')

export const SET_FILTERS = makeConstant('SET_FILTERS')
export const SET_NEW_FILTERS = makeConstant('SET_NEW_FILTERS')
export const SET_NEW_SORTS = makeConstant('SET_NEW_SORTS')
export const SET_FILTER_KNOWN_USERS = makeConstant('SET_FILTER_KNOWN_USERS')
export const SET_PAGINATION = makeConstant('SET_PAGINATION')
export const SET_CUSTOM_INTERVAL = makeConstant('SET_CUSTOM_INTERVAL')

export const SET_SHOW_MORE = makeConstant('SET_SHOW_MORE')

export const INITIALIZE_PRESENCE_FOR_USERS = makeConstant('INITIALIZE_PRESENCE_FOR_USERS')
export const SET_PRESENCE_IS_RECEIVING = makeConstant('SET_PRESENCE_IS_RECEIVING')

export const BOOTSTRAP_USER = makeConstant('BOOTSTRAP_USER')
export const BOOTSTRAP_USER_SUCCESS = makeConstant('BOOTSTRAP_USER_SUCCESS')
export const BOOTSTRAP_USER_ERROR = makeConstant('BOOTSTRAP_USER_ERROR')

export const SET_BUFFERED_USERS = makeConstant('SET_BUFFERED_USERS')

export const SET_PROCESS_ALL_USERS = makeConstant('SET_PROCESS_ALL_USERS')
export const ADD_USER_PROCESSED = makeConstant('ADD_USER_PROCESSED')
export const REMOVE_USER_PROCESSED = makeConstant('REMOVE_USER_PROCESSED')
export const REMOVE_USER_PROCESSED_DELAYED = makeConstant('REMOVE_USER_PROCESSED_DELAYED')

export const SEND_ACTIVE_STATUS = makeConstant('SEND_ACTIVE_STATUS')
export const SET_PRESENCE_PROBLEMS = makeConstant('SET_PRESENCE_PROBLEMS')
export const SET_PRESENCE_LOADING = makeConstant('SET_PRESENCE_LOADING')

export const SET_NEW_LIVE_USERS = makeConstant('SET_NEW_LIVE_USERS')

export const GET_PRESENCE_STATE_ON_INTERVAL = makeConstant('GET_PRESENCE_STATE_ON_INTERVAL')
export const CANCEL_PRESENCE_INTERVAL = makeConstant('CANCEL_PRESENCE_INTERVAL')

export const SET_HAS_PROCESSED_USERS = makeConstant('SET_HAS_PROCESSED_USERS')

export const PresenceChannel = Object.freeze({
  ORG: 'ORG',
  ORG_PRIVATE: 'ORG_PRIVATE',
  USER: 'USER',
})

export const PhoenixStatus = Object.freeze({
  CONNECTED: 'CONNECTED',
  DISCONNECTING: 'DISCONNECTING',
  DISCONNECTED: 'DISCONNECTED',
})

export const WORKER_DEBUG_KEY = 'presence-worker-debug'

export const MESSAGE_SENT = makeConstant('MESSAGE_SENT')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/presence/constants.js